module.exports = __webpack_public_path__ + "static/media/book.66d47cef.png";